export function transformTimeStringToMinutes(time: string): number {
  const [hoursStr, minutesStr] = time.split(':');

  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);

  if (isNaN(hours) || isNaN(minutes)) {
    throw new Error('Ungültiges Zeitformat. Erwartet: HH:MM');
  }

  return hours * 60 + minutes;
}
